export class TaskList {
    id = ""
    name = ""
    orderIndex = 1
    content = "";
    /**
     * @type {TaskList}
     */
    parent;
    constructor(values={}) {
        Object.assign(this, values)
    }
}